// The Founder Box: a beta offer in the diamond shop, one per account (owner's call, 2026-10-14).
// It gives the Founder outfit and the Founder chat badge, both bound to the account for good.
// An admin retires it from the Admin tab (kv 'founder-open'); once retired the shop hides it,
// and every trainer who bought it keeps both.
import type { TrainerDTO } from './protocol.ts';

export const FOUNDER = {
  /** Shop offer id (sent as { t: 'shop', offer }). */
  offer: 'founder-box',
  /** Diamond price (pokeidle's Founder Box price). */
  price: 150,
  outfit: 'founder',
  badge: { id: 'founder', name: 'Founder', glyph: '✦' },
} as const;

/** Whether the Diamond shop shows the Founder Box card: on sale and not yet bought. */
export const founderOffered = (open: boolean, t: Pick<TrainerDTO, 'founder'>) => open && !t.founder;

